export const user_data = () => {
    const u = localStorage.getItem('sw_user')
    return JSON.parse(u)
}